import React from 'react';
import { timeframeRangeSuffix } from './helpers/timeframeRange';

/**
 * RTF-4257: supporting UI that shows the date range covered by the currently
 * selected timeframe, rendered to the RIGHT of a timeframe dropdown — never
 * inside the dropdown label or its options.
 *
 * Renders nothing for Custom / unknown timeframes (those reveal the date pickers
 * instead) or when the range can't be computed (e.g. Lifetime with no created_at).
 * Reuses timeframeRangeSuffix so the parenthesized format matches everywhere.
 *
 * @param {object}  props
 * @param {string}  props.timeframe     selected timeframe id (today|last30|custom|...)
 * @param {string}  [props.timezone]    business timezone
 * @param {string}  [props.lifetimeStart] ISO date for the Lifetime floor (created_at)
 * @param {string}  [props.className]   extra classes for the wrapping span
 */
export default function TimeframeRangeLabel({ timeframe, timezone, lifetimeStart, className = '' }) {
    const suffix = timeframeRangeSuffix(timeframe, timezone, lifetimeStart);
    if (!suffix) {
        return null;
    }

    return (
        <span className={`timeframe-range-label text-muted text-nowrap ${className}`.trim()}>
            {suffix.trim()}
        </span>
    );
}
